export default "https://cdn-static.gokick.com/assets/adaefb0e3fd6b18bbcda680789a7f58b9251a870/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";